export const SERVER_URL = "https://husky.thebusybee.app";

export const IMAGE_URL = "https://bucket.thebusybee.app/busybeedev/";

